import React from 'react';
import { Database } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';

const DatabaseStatsGrid = ({ productionStatus }) => {
  return (
    <Card className="glass-card border-white/20">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Database className="w-5 h-5 text-primary" />
          <div>
            <CardTitle>Database Statistics</CardTitle>
            <CardDescription className="mt-1">Current record counts</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {productionStatus?.database_stats && Object.entries(productionStatus.database_stats).map(([key, value]) => (
            <div key={key} className="text-center p-4 rounded-lg bg-secondary/50">
              <div className="text-2xl font-bold text-primary">{value}</div>
              <div className="text-xs text-muted-foreground mt-1 capitalize">{key.replace(/_/g, ' ')}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DatabaseStatsGrid;
